import HttpService from "@/services/HttpService";

const LoginServices = {
	async obtenerUsuario() {
		return await HttpService.get('/operadora/getDataUser');
	},
    async obtenerAgencia() {
        return await HttpService.get('/operadora/getAgencyUser');
    },
     async sso_login(user, password){
        return await HttpService.post("/operadora/sso_login", {
            user: user,
            password: password
        })
     }
}
export default LoginServices;